module.exports = (__webpack_require__(4))(1);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react/react.js from dll-reference carbon.vendor
// module id = 2
// module chunks = 0